import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { RichTextComponent } from 'src/app/shared/components/rich-text/rich-text.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { DisplayByTypeDirective } from '../../display-by-type.directive';
import { combineLatest, startWith } from 'rxjs';
import { SvgIconComponent } from 'angular-svg-icon';
import { AutoResizeDirective } from 'src/app/directves/autoresize.directive';

@Component({
    selector: 'que-title-question',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MatCheckboxModule, RichTextComponent, TranslateDirective, TranslatePipe, DisplayByTypeDirective, SvgIconComponent, AutoResizeDirective],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: TitleQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TitleQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './title-question.component.html',
    styleUrls: ['./title-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Input() question?: Question | null;
  @Input() typeId?: number;
  #operationsStore = inject(MiniOperationsStore)
  // isOrange: string = '';
  typeImage: string = "";
  color$ = inject(QuestionnaireStore).mainColor$;
  #builder = inject(FormBuilder);
  // questionForm = this.#builder.group({
  //   id: [-1],
  //   type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
  //   title: new FormControl<string>('', [Validators.required]),
  //   text: new FormControl<string>(''),
  //   optionsList: new FormControl<OptionsList | null>(null),

  //   requierd: new FormControl<boolean>(false),
  //   collectionQuestionId: new FormControl<number | null>(null),
  //   stepId: [-1],
  // });

  text = new FormControl<string | null>(null);
  title = new FormControl<string>('', [Validators.required]);
  titleToData = new FormControl<string | null>(null);

  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    combineLatest([
      this.text.valueChanges.pipe(startWith(this.text.value)),
      this.title.valueChanges.pipe(startWith(this.title.value)),
      this.titleToData.valueChanges.pipe(startWith(this.titleToData.value))
    ]).subscribe(([text, title,titleToData]) => {
      this.registerOnChangeCallback({ text, title,titleToData});
    });
  }

  
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.text.valid && this.title.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  writeValue(obj: any): void {
    if (obj?.text)
      this.text.patchValue(obj.text)
    if (obj?.title)
      this.title.patchValue(obj.title)
    if (obj?.titleToData)
      this.titleToData.patchValue(obj.titleToData)
    // this.questionForm.patchValue({ ...obj }, { emitEvent: false });
    // this.typeImage=obj.type.image??"";
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
}
